import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel, ConsultaSeguimentoOutroFieldModel } from '../../model-consultaSeguimento'

export interface ConsultaSeguimentoPergunta20Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_20_HEADER?: SimNaoEnum
  PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR?: SimNaoEnum
  PERGUNTA_20_EXEMPLOS?: Record<ConsultaSeguimentoPergunta20ExemplosEnum, SimNaoEnum | undefined>
  PERGUNTA_20_OUTRO?: ConsultaSeguimentoOutroFieldModel
}

export enum ConsultaSeguimentoPergunta20ExemplosEnum {
  RI_OU_GARGALHA = 'RI_OU_GARGALHA',
  FALA_OU_EMITE_SOM = 'FALA_OU_EMITE_SOM',
  PEDE_MAIS = 'PEDE_MAIS',
}
